<template>
  <div>
    <div v-if="displayWebsite == true" style="padding: 1rem;">
      <h2>Overview</h2>
      <div v-if="userLeveL == 'Developer'">
        {{ userLeveL }}
      </div>
    </div>
    <div v-if="displayWebsite == false" id="welcome-grid">
      <div id="welcome-container">
        <div id="landing-header">
          <h1>Welcome to <span class="orangeText">NeuroLeapOne</span></h1>
          <small>NeuroLeap One Cloud is an all-in one platform for specialists, parents/caretakers, and more to get actionable insights and care for child / patients.</small>
        </div>
        <div id="services-container">
          <div class="service-card-container">
            <svg width="78" height="78" viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="78" height="78" rx="12.2697" fill="#F7F7F7"/>
              <ellipse cx="20.7061" cy="43.7162" rx="2.89133" ry="4.337" transform="rotate(37.2213 20.7061 43.7162)" fill="#B9B9B9"/>
              <ellipse cx="2.89133" cy="4.337" rx="2.89133" ry="4.337" transform="matrix(-0.796305 0.604895 0.604895 0.796305 38.2129 38.5137)" fill="#B9B9B9"/>
              <path d="M23.4623 33.398L20.6843 60.3838C20.5088 62.0887 21.8465 63.5712 23.5604 63.5712H37.1742C38.9636 63.5712 40.3234 61.9621 40.025 60.1977L35.4612 33.2119C35.226 31.8209 34.0212 30.8027 32.6104 30.8027H26.3384C24.8562 30.8027 23.614 31.9236 23.4623 33.398Z" fill="#F6A620"/>
              <circle cx="29.0299" cy="26.7067" r="10.8425" fill="#B9B9B9" stroke="#F7F7F7" stroke-width="1.92755"/>
              <ellipse cx="47.1766" cy="49.5285" rx="2.02393" ry="3.0359" transform="rotate(37.2213 47.1766 49.5285)" fill="#B9B9B9"/>
              <ellipse cx="2.02393" cy="3.0359" rx="2.02393" ry="3.0359" transform="matrix(-0.796305 0.604895 0.604895 0.796305 59.4314 45.8867)" fill="#B9B9B9"/>
              <path d="M49.1066 42.305L47.1621 61.195C47.0392 62.3884 47.9756 63.4262 49.1753 63.4262H58.7049C59.9576 63.4262 60.9094 62.2998 60.7005 61.0648L57.5059 42.1747C57.3412 41.201 56.4979 40.4883 55.5103 40.4883H51.1199C50.0824 40.4883 49.2129 41.2729 49.1066 42.305Z" fill="#F6A620"/>
              <circle cx="53.0056" cy="37.6218" r="7.58975" fill="#B9B9B9" stroke="#F7F7F7" stroke-width="1.34929"/>
            </svg>
            <h5>Parents / Caretakers</h5>
            <small>Monitor and stay up-to-date on your child’s progress on their interventions, assessments, and more.</small>
            <div>
              <router-link to="/pageNotAvailable">
                <button class="secondary-color-button-sm-global">Enter</button>
              </router-link>
            </div>
          </div>
          <div class="service-card-container">
            <svg width="79" height="78" viewBox="0 0 79 78" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" width="78" height="78" rx="12.2697" fill="#F7F7F7"/>
              <path d="M33.6294 36.9831C31.5374 36.9831 29.5312 36.1521 28.052 34.6728C26.5727 33.1936 25.7417 31.1874 25.7417 29.0954V22.7853C25.7417 22.3669 25.9079 21.9657 26.2038 21.6698C26.4996 21.374 26.9009 21.2078 27.3193 21.2078H28.8968C29.3152 21.2078 29.7164 21.0416 30.0123 20.7457C30.3081 20.4499 30.4743 20.0486 30.4743 19.6303C30.4743 19.2119 30.3081 18.8106 30.0123 18.5148C29.7164 18.2189 29.3152 18.0527 28.8968 18.0527H27.3193C26.0641 18.0527 24.8603 18.5513 23.9728 19.4389C23.0853 20.3264 22.5867 21.5302 22.5867 22.7853V29.0954C22.5887 30.8776 23.0233 32.6327 23.8531 34.2099C24.6829 35.7871 25.8832 37.1393 27.3508 38.1504C28.7623 39.3924 29.9067 40.9081 30.7148 42.6056C31.5229 44.3032 31.9778 46.1472 32.0518 48.0258C32.0518 50.9545 33.2153 53.7632 35.2862 55.8341C37.3571 57.905 40.1658 59.0685 43.0945 59.0685C46.0232 59.0685 48.832 57.905 50.9029 55.8341C52.9738 53.7632 54.1372 50.9545 54.1372 48.0258V46.2274C55.6243 45.8434 56.9203 44.9303 57.7823 43.6592C58.6443 42.388 59.013 40.8461 58.8195 39.3225C58.626 37.7989 57.8834 36.3982 56.7311 35.3829C55.5787 34.3677 54.0955 33.8075 52.5597 33.8075C51.0239 33.8075 49.5407 34.3677 48.3884 35.3829C47.236 36.3982 46.4934 37.7989 46.2999 39.3225C46.1064 40.8461 46.4752 42.388 47.3371 43.6592C48.1991 44.9303 49.4951 45.8434 50.9822 46.2274V48.0258C50.9822 50.1177 50.1512 52.124 48.6719 53.6032C47.1927 55.0824 45.1865 55.9134 43.0945 55.9134C41.0026 55.9134 38.9963 55.0824 37.5171 53.6032C36.0379 52.124 35.2069 50.1177 35.2069 48.0258C35.2849 46.1448 35.7447 44.2994 36.5583 42.6017C37.3719 40.9041 38.5223 39.3896 39.9395 38.1504C41.4013 37.1358 42.5954 35.7821 43.4196 34.2051C44.2438 32.6281 44.6736 30.8748 44.6721 29.0954V22.7853C44.6721 21.5302 44.1735 20.3264 43.2859 19.4389C42.3984 18.5513 41.1946 18.0527 39.9395 18.0527H38.3619C37.9436 18.0527 37.5423 18.2189 37.2465 18.5148C36.9506 18.8106 36.7844 19.2119 36.7844 19.6303C36.7844 20.0486 36.9506 20.4499 37.2465 20.7457C37.5423 21.0416 37.9436 21.2078 38.3619 21.2078H39.9395C40.3579 21.2078 40.7591 21.374 41.055 21.6698C41.3508 21.9657 41.517 22.3669 41.517 22.7853V29.0954C41.517 30.1312 41.313 31.1569 40.9166 32.1139C40.5202 33.0709 39.9392 33.9404 39.2068 34.6728C38.4743 35.4053 37.6048 35.9863 36.6478 36.3827C35.6909 36.7791 34.6652 36.9831 33.6294 36.9831ZM52.5597 43.2932C51.7229 43.2932 50.9204 42.9608 50.3287 42.3691C49.7371 41.7774 49.4046 40.9749 49.4046 40.1381C49.4046 39.3014 49.7371 38.4989 50.3287 37.9072C50.9204 37.3155 51.7229 36.9831 52.5597 36.9831C53.3965 36.9831 54.199 37.3155 54.7907 37.9072C55.3824 38.4989 55.7148 39.3014 55.7148 40.1381C55.7148 40.9749 55.3824 41.7774 54.7907 42.3691C54.199 42.9608 53.3965 43.2932 52.5597 43.2932Z" fill="#A8A8A8"/>
              <mask id="path-3-inside-1_931_4240" fill="white">
              <path d="M56.9497 39.7326C57.2596 39.7326 57.5143 39.4805 57.4773 39.1727C57.3896 38.4443 57.1317 37.7438 56.7212 37.1294C56.2063 36.3588 55.4745 35.7582 54.6183 35.4036C53.7621 35.0489 52.8199 34.9561 51.911 35.1369C51.1862 35.2811 50.5085 35.594 49.9314 36.0471C49.6877 36.2385 49.6895 36.597 49.9086 36.8161C50.1278 37.0353 50.481 37.031 50.7318 36.8489C51.1465 36.5479 51.6231 36.3385 52.13 36.2377C52.8212 36.1002 53.5377 36.1708 54.1888 36.4405C54.8399 36.7102 55.3964 37.1669 55.788 37.7529C56.0751 38.1826 56.264 38.6677 56.3444 39.1737C56.393 39.4798 56.6397 39.7326 56.9497 39.7326Z"/>
              </mask>
              <path d="M56.9497 39.7326C57.2596 39.7326 57.5143 39.4805 57.4773 39.1727C57.3896 38.4443 57.1317 37.7438 56.7212 37.1294C56.2063 36.3588 55.4745 35.7582 54.6183 35.4036C53.7621 35.0489 52.8199 34.9561 51.911 35.1369C51.1862 35.2811 50.5085 35.594 49.9314 36.0471C49.6877 36.2385 49.6895 36.597 49.9086 36.8161C50.1278 37.0353 50.481 37.031 50.7318 36.8489C51.1465 36.5479 51.6231 36.3385 52.13 36.2377C52.8212 36.1002 53.5377 36.1708 54.1888 36.4405C54.8399 36.7102 55.3964 37.1669 55.788 37.7529C56.0751 38.1826 56.264 38.6677 56.3444 39.1737C56.393 39.4798 56.6397 39.7326 56.9497 39.7326Z" stroke="#D9D9D9" stroke-width="12.6202" stroke-linejoin="bevel" mask="url(#path-3-inside-1_931_4240)"/>
              <ellipse cx="29.1632" cy="19.5852" rx="1.64" ry="1.87429" fill="#F3A304"/>
              <ellipse cx="37.5987" cy="19.5852" rx="1.64" ry="1.87429" fill="#F3A304"/>
            </svg>
            <h5>Specialists</h5>
            <small>Access intervention plans, data, and assessments related to your child/patient.</small>
            <div>
              <router-link to="/specialist">
                <button class="secondary-color-button-sm-global">Enter</button>
              </router-link>
            </div>
          </div>
          <div class="service-card-container">
            <svg width="79" height="78" viewBox="0 0 79 78" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" width="78" height="78" rx="12.2697" fill="#F7F7F7"/>
              <path d="M25 35.6621V50.6621C25 51.5462 25.3512 52.394 25.9763 53.0191C26.6014 53.6443 27.4493 53.9954 28.3333 53.9954H51.6667C52.5507 53.9954 53.3986 53.6443 54.0237 53.0191C54.6488 52.394 55 51.5462 55 50.6621V35.6621" stroke="#7C7C7C" stroke-width="2.5"/>
              <path d="M45 54.3333V44.3333C45 43.4493 44.6488 42.6014 44.0237 41.9763C43.3986 41.3512 42.5507 41 41.6667 41H38.3333C37.4493 41 36.6014 41.3512 35.9763 41.9763C35.3512 42.6014 35 43.4493 35 44.3333V54.3333" stroke="#F6A620" stroke-width="2.5" stroke-miterlimit="16"/>
              <path d="M56.3569 34.6047L53.5336 24.723C53.4738 24.5141 53.3476 24.3304 53.1741 24.1995C53.0006 24.0687 52.7892 23.998 52.5719 23.998H45.8269L46.6186 33.5047C46.6308 33.6575 46.6792 33.8052 46.7598 33.9356C46.8403 34.066 46.9507 34.1754 47.0819 34.2547C47.7319 34.643 49.0019 35.3597 49.9936 35.6647C51.6869 36.1864 54.1602 35.998 55.5702 35.8247C55.7073 35.807 55.8389 35.7596 55.9557 35.6858C56.0726 35.612 56.1719 35.5135 56.2469 35.3974C56.3218 35.2812 56.3704 35.1501 56.3894 35.0132C56.4084 34.8763 56.3973 34.7369 56.3569 34.6047Z" stroke="#7C7C7C" stroke-width="2.5"/>
              <path d="M43.3262 35.6647C44.2729 35.373 45.4729 34.708 46.1429 34.3114C46.2988 34.2181 46.4253 34.0828 46.5078 33.921C46.5904 33.7592 46.6256 33.5773 46.6096 33.3964L45.8262 23.998H34.1596L33.3762 33.3964C33.3599 33.5776 33.395 33.7598 33.4775 33.9219C33.5601 34.0841 33.6867 34.2197 33.8429 34.313C34.5129 34.708 35.7129 35.373 36.6596 35.6647C39.1479 36.4314 40.8379 36.4314 43.3262 35.6647Z" stroke="#7C7C7C" stroke-width="2.5"/>
              <path d="M26.4576 24.723L23.6343 34.6064C23.5945 34.7383 23.5838 34.8774 23.6031 35.0139C23.6224 35.1504 23.6711 35.2811 23.746 35.3968C23.8208 35.5126 23.92 35.6107 24.0365 35.6843C24.1531 35.7579 24.2843 35.8052 24.421 35.823C25.8293 35.998 28.3043 36.1847 29.9976 35.6647C30.9893 35.3597 32.261 34.643 32.9093 34.2564C33.0407 34.1769 33.1512 34.0673 33.2318 33.9365C33.3124 33.8058 33.3607 33.6578 33.3726 33.5047L34.1643 23.998H27.4193C27.202 23.998 26.9906 24.0687 26.8171 24.1995C26.6436 24.3304 26.5174 24.5141 26.4576 24.723Z" stroke="#7C7C7C" stroke-width="2.5"/>
            </svg>
            <h5>Marketplace</h5>
            <small>Shop for applications / activities.</small>
            <div>
              <router-link to="/rolesPage/searchAppAdminApps/viewAppAdminApps">
                <button class="secondary-color-button-sm-global">Enter</button>
              </router-link>
            </div>
          </div>
        </div>
        <div id="get-started-container">
          <div>
            <h6>Start assessments and treatments with NeuroLeap One</h6>
            <small>Support your children/patients in their growth and development.</small>
          </div>
          <div>
            <router-link to="/register">
              <button class="primary-button-sm-global">Get Started</button>
            </router-link>
          </div>
        </div>
      </div>
      <div id="welcome-sidebar-container">
        <h5>APPS AND ACTIVITIES</h5>
        <div>
          <router-link to="/activities">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.7973 11.5L5.6127 20.9985L3.99731 22V1L20.7973 11.5ZM17.7281 11.5L5.6127 3.90769V19.0923L17.7281 11.5Z" fill="#404040"/>
            </svg>
            Start or continue an activity
            <svg width="12" height="24" viewBox="0 0 12 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.999839 7.0607L2.06084 6.0007L7.83984 11.7777C7.93299 11.8703 8.00692 11.9803 8.05737 12.1016C8.10782 12.2228 8.13379 12.3529 8.13379 12.4842C8.13379 12.6155 8.10782 12.7456 8.05737 12.8668C8.00692 12.9881 7.93299 13.0981 7.83984 13.1907L2.06084 18.9707L1.00084 17.9107L6.42484 12.4857L0.999839 7.0607Z" fill="#5B5B5B"/>
            </svg>
          </router-link>
        </div>
        <div>
          <router-link to="/rolesPage/searchAppAdminApps/viewAppAdminApps">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.4995 3.49805C16.7039 3.49805 15.9408 3.81412 15.3782 4.37673C14.8156 4.93934 14.4995 5.7024 14.4995 6.49805C14.4995 7.2937 14.8156 8.05676 15.3782 8.61937C15.9408 9.18198 16.7039 9.49805 17.4995 9.49805C18.2952 9.49805 19.0582 9.18198 19.6208 8.61937C20.1834 8.05676 20.4995 7.2937 20.4995 6.49805C20.4995 5.7024 20.1834 4.93934 19.6208 4.37673C19.0582 3.81412 18.2952 3.49805 17.4995 3.49805ZM12.4995 6.49805C12.4995 5.17196 13.0263 3.90019 13.964 2.96251C14.9017 2.02483 16.1734 1.49805 17.4995 1.49805C18.8256 1.49805 20.0974 2.02483 21.035 2.96251C21.9727 3.90019 22.4995 5.17196 22.4995 6.49805C22.4995 7.82413 21.9727 9.0959 21.035 10.0336C20.0974 10.9713 18.8256 11.498 17.4995 11.498C16.1734 11.498 14.9017 10.9713 13.964 10.0336C13.0263 9.0959 12.4995 7.82413 12.4995 6.49805ZM1.99951 1.99805H10.9995V10.998H1.99951V1.99805ZM3.99951 3.99805V8.99805H8.99951V3.99805H3.99951ZM1.99951 12.998H10.9995V21.998H1.99951V12.998ZM3.99951 14.998V19.998H8.99951V14.998H3.99951ZM12.9995 12.998H21.9995V21.998H12.9995V12.998ZM19.9995 14.998H14.9995V19.998H19.9995V14.998Z" fill="#404040"/>
            </svg>
            App Creator and Manager
            <svg width="12" height="24" viewBox="0 0 12 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.999839 7.0607L2.06084 6.0007L7.83984 11.7777C7.93299 11.8703 8.00692 11.9803 8.05737 12.1016C8.10782 12.2228 8.13379 12.3529 8.13379 12.4842C8.13379 12.6155 8.10782 12.7456 8.05737 12.8668C8.00692 12.9881 7.93299 13.0981 7.83984 13.1907L2.06084 18.9707L1.00084 17.9107L6.42484 12.4857L0.999839 7.0607Z" fill="#5B5B5B"/>
            </svg>
          </router-link>
        </div>
        <h5>OTHER ROLES</h5>
        <div>
          <router-link to="/pageNotAvailable">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 2H9C7.897 2 7 2.897 7 4V10H5C3.897 10 3 10.897 3 12V21C3 21.2652 3.10536 21.5196 3.29289 21.7071C3.48043 21.8946 3.73478 22 4 22H20C20.2652 22 20.5196 21.8946 20.7071 21.7071C20.8946 21.5196 21 21.2652 21 21V4C21 2.897 20.103 2 19 2ZM5 12H11V20H5V12ZM19 20H13V12C13 10.897 12.103 10 11 10H9V4H19V20Z" fill="black"/>
              <path d="M11 6H13V8H11V6ZM15 6H17V8H15V6ZM15 10.031H17V12H15V10.031ZM15 14H17V16H15V14ZM7 14.001H9V16.001H7V14.001Z" fill="black"/>
            </svg>
            Organizations
            <svg width="12" height="24" viewBox="0 0 12 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.999839 7.0607L2.06084 6.0007L7.83984 11.7777C7.93299 11.8703 8.00692 11.9803 8.05737 12.1016C8.10782 12.2228 8.13379 12.3529 8.13379 12.4842C8.13379 12.6155 8.10782 12.7456 8.05737 12.8668C8.00692 12.9881 7.93299 13.0981 7.83984 13.1907L2.06084 18.9707L1.00084 17.9107L6.42484 12.4857L0.999839 7.0607Z" fill="#5B5B5B"/>
            </svg>
          </router-link>
        </div>
        <div>
          <router-link to="/pageNotAvailable">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.875 2.1875V16.875H19.0625C19.3111 16.875 19.5496 16.9738 19.7254 17.1496C19.9012 17.3254 20 17.5639 20 17.8125C20 18.0611 19.9012 18.2996 19.7254 18.4754C19.5496 18.6512 19.3111 18.75 19.0625 18.75H0.9375C0.68886 18.75 0.450403 18.6512 0.274587 18.4754C0.098772 18.2996 0 18.0611 0 17.8125L0 2.1875C0 1.93886 0.098772 1.7004 0.274587 1.52459C0.450403 1.34877 0.68886 1.25 0.9375 1.25C1.18614 1.25 1.4246 1.34877 1.60041 1.52459C1.77623 1.7004 1.875 1.93886 1.875 2.1875ZM19.725 5.35L13.1625 11.9125C12.9867 12.0881 12.7484 12.1867 12.5 12.1867C12.2516 12.1867 12.0133 12.0881 11.8375 11.9125L8.75 8.825L5.35 12.225C5.17232 12.3908 4.93719 12.4811 4.6942 12.4769C4.45121 12.4727 4.21935 12.3743 4.0475 12.2025C3.87566 12.0307 3.77727 11.7988 3.77307 11.5558C3.76887 11.3128 3.8592 11.0777 4.025 10.9L8.0875 6.8375C8.26328 6.66194 8.50156 6.56332 8.75 6.56332C8.99844 6.56332 9.23672 6.66194 9.4125 6.8375L12.5 9.925L18.4 4.025C18.5777 3.8592 18.8128 3.76887 19.0558 3.77307C19.2988 3.77727 19.5307 3.87566 19.7025 4.0475C19.8743 4.21935 19.9727 4.45121 19.9769 4.6942C19.9811 4.93719 19.8908 5.17232 19.725 5.35Z" fill="black"/>
            </svg>
            Statistician/Analysts
            <svg width="12" height="24" viewBox="0 0 12 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.999839 7.0607L2.06084 6.0007L7.83984 11.7777C7.93299 11.8703 8.00692 11.9803 8.05737 12.1016C8.10782 12.2228 8.13379 12.3529 8.13379 12.4842C8.13379 12.6155 8.10782 12.7456 8.05737 12.8668C8.00692 12.9881 7.93299 13.0981 7.83984 13.1907L2.06084 18.9707L1.00084 17.9107L6.42484 12.4857L0.999839 7.0607Z" fill="#5B5B5B"/>
            </svg>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "landingPage",
  computed: {
    displayWebsite() {
      return this.$store.getters.isLoggedIn;
    },
    userLeveL() {
      return this.$store.getters.getUserLevel;
    },
  },
};
</script>

<style lang="scss" scoped>
  @use 'sharedSCSS/globalSharedVariables';

  #welcome-grid {
    display: grid;
    grid-template-columns: 1fr 400px;
    column-gap: 1rem;
    height: 100vh;

    #welcome-container {
      padding: 1rem;

      small {
        color: globalSharedVariables.$grey-700;
      }

      #landing-header {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-bottom: 1rem;
        font-size: 24px;

        .orangeText {
          color: globalSharedVariables.$brand-600;
        }

        h1 {
          font-size: 40px;
        }
      }

      #services-container {
        display: flex;
        justify-content: space-between;

        h5 {
          margin: 0;
        }

        .service-card-container {
          padding: 1rem;
          display: grid;
          grid-template-rows: 1fr 1fr 1fr 1fr;
          width: 288px;
          height: 315px;
          border: solid 1px globalSharedVariables.$grey-300;
          border-radius: 5px;

          > * {
            display: flex;
            align-items: center;
          }
        }
      }

      #get-started-container {
        background-color: globalSharedVariables.$brand-50;
        border: solid 1px globalSharedVariables.$brand-100;
        padding: 1rem;
        border-radius: 5px;
        display: grid;
        grid-template-columns: 1fr auto;
        margin-top: 2rem;

        h6 {
          color: globalSharedVariables.$brand-900;
        }

        small {
          color: globalSharedVariables.$brand-800;
        }

        > div:nth-child(2) {
          display: flex;
          align-items: center;
        }
      }
    }

    #welcome-sidebar-container {
      background-color: globalSharedVariables.$grey-50;
      border: solid 1px globalSharedVariables.$grey-200;
      padding: 1rem;

      h5 {
        color: globalSharedVariables.$grey-700;
        margin: 2rem 0;
      }

      > div > a {
        display: flex;
        justify-content: space-between;
        margin: 1rem 0;
        color: globalSharedVariables.$grey-900;
      }
    }
  }
</style>